import { Pipe, PipeTransform } from '@angular/core';
import { FilterItemInterface } from 'app/site-filters/models';

@Pipe({
  name: 'filterSiteFilterItems',
})
export class FilterSiteItemsPipe implements PipeTransform {
  public transform(filterItems: FilterItemInterface[], searchText: string): FilterItemInterface[] {
    if(!filterItems) { return []; }
    if(!searchText) { return filterItems; }

    return filterItems.filter((filterItem: FilterItemInterface) =>
      filterItem.name.toLowerCase().includes(searchText.toLowerCase()),
      );
  }
}
